export * from './abschnitt-post-request.interface';
export * from './abschnitt-post-response.interface';
export * from './abschnitt-post.shapes';
